<template>
    <ConfirmDialog group="dialog" />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('Free1.view.Heading') }}</strong>
                </h4>

                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.CompanyName') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ company_name }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="title_en" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.Manager') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ manager_name }}</p>
                    </div>
                </div>

                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.JobName') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ job_posting_title }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.JobSelection') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ job_selection }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="title_en" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.JobPosition') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ job_positions }}</p>
                    </div>
                </div>

                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.Pay') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p v-if="pay_type === '' || pay_type === null">N/A</p>
                        <p v-else-if="pay_type == 'daily_wage'">{{ formatSalary(salary) }} {{ $t('Won') }} - {{ $t('daily_wage') }}</p>
                        <p v-else-if="pay_type == 'hourly_wage'">{{ formatSalary(salary) }} {{ $t('Won') }} - {{ $t('hourly_wage') }}</p>
                        <p v-else-if="pay_type == 'salary'">{{ formatSalary(salary) }} {{ $t('Won') }} - {{ $t('salary') }}</p>
                        <!-- <p>{{ salary }} 원 - {{ pay_type === 'daily_wage' ? '일급' : '시급' }}</p> -->
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.WorkType') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p v-if="working_mode === 'full_time'">{{ $t('full_time') }} - {{ $t('Probationary') }} ({{ probation }} {{ $t('Day1') }})</p>
                        <p v-else-if="working_mode === 'contract_worker'">{{ $t('contract_worker') }} -{{ $t('Probationary') }} ({{ probation }} {{ $t('Day1') }})</p>
                        <p v-else-if="working_mode === 'part_time_job'">{{ $t('part_time_job') }} - {{ $t('Probationary') }} ({{ probation }} {{ $t('Day1') }})</p>
                        <p v-else-if="working_mode === 'dispatch'">{{ $t('dispatch') }} - {{ $t('Probationary') }} ({{ probation }} {{ $t('Day1') }})</p>
                        <p v-else-if="working_mode === 'internship'">{{ $t('internship') }} - {{ $t('Probationary') }} ({{ probation }} {{ $t('Day1') }})</p>
                        <p v-else-if="working_mode === 'freelancer'">{{ $t('freelancer') }} - {{ $t('Probationary') }} ({{ probation }} {{ $t('Day1') }})</p>
                        <p v-else-if="working_mode === 'etc'">{{ $t('etc') }} - {{ $t('Probationary') }} ({{ probation }} {{ $t('Day1') }})</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="title_en" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.WorkTime') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p class="p-right" v-if="job_working_days.length == 7">
                            {{ job_working_days.length }}일 (월,화,수,목,금,토,일) ~ {{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} - {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}
                        </p>
                        <p class="p-right" v-if="job_working_days.length == 6">
                            {{ job_working_days.length }}일 (월,화,수,목,금,토) ~ {{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} - {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}
                        </p>
                        <p class="p-right" v-if="job_working_days.length == 5">
                            {{ job_working_days.length }}일 (월,화,수,목,금) ~ {{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} - {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}
                        </p>
                        <p class="p-right" v-if="job_working_days.length == 4">
                            {{ job_working_days.length }}일 (월,화,수,목) ~ {{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} - {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}
                        </p>
                        <p class="p-right" v-if="job_working_days.length == 3">
                            {{ job_working_days.length }}일 (월,화,수) ~ {{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} - {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}
                        </p>
                        <p class="p-right" v-if="job_working_days.length == 2">
                            {{ job_working_days.length }}일 (월,화) ~ {{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} - {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}
                        </p>
                        <p class="p-right" v-if="job_working_days.length == 1">
                            {{ job_working_days.length }}일 (월) ~ {{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} - {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}
                        </p>
                        <p class="p-right" v-if="job_working_days.length == 0">요일협의 ~ {{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} - {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}</p>
                        <!-- <p v-if="job_working_days.length > 0">
                            {{ job_working_days.length }} {{ $t('Days') }} ~
                            <span v-if="job_working_days.length === 1">{{ weekdays[job_working_days[0] - 1] }}</span>
                            <span v-else> {{ weekdays[job_working_days[0] - 1] }} - {{ weekdays[job_working_days[job_working_days.length - 1] - 1] }} ~ {{ working_hour_from === 'NaN:NaN' ? '--' : working_hour_from }} - {{ working_hour_end === 'NaN:NaN' ? '--' : working_hour_end }}</span>
                        </p> -->
                    </div>
                </div>

                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.Career') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p v-if="career === 'experience'">{{ $t('experience') }} / {{ min_experience === null || min_experience === 'null'  ? 'N/A' : min_experience + '&nbsp;' + '년제' }} - {{ max_experience === null || max_experience === 'null' ? 'N/A' : max_experience + '&nbsp;' + '년제' }}</p>
                        <p v-else-if="career === 'elementary'">{{ $t('elementary') }} / {{ min_experience === null || min_experience === 'null' ? 'N/A' : min_experience + '&nbsp;' + '년제' }} - {{ max_experience === null || max_experience === 'null' ? 'N/A' : max_experience + '&nbsp;' + '년제' }}</p>
                        <p v-else-if="career === 'intermediate'">{{ $t('intermediate') }} / {{ min_experience === null || min_experience === 'null' ? 'N/A' : min_experience + '&nbsp;' + '년제' }} - {{ max_experience === null || max_experience === 'null' ? 'N/A' : max_experience + '&nbsp;' + '년제' }}</p>
                        <p v-else-if="career === 'advanced'">{{ $t('advanced') }} / {{ min_experience === null || min_experience === 'null' ? 'N/A' : min_experience + '&nbsp;' + '년제'}} - {{ max_experience === null || max_experience === 'null' ? 'N/A' : max_experience + '&nbsp;' + '년제' }}</p>
                        <p v-else-if="career === 'newcomer'">{{ $t('newcomer') }} / {{ min_experience === null || min_experience === 'null' ? 'N/A' : min_experience + '&nbsp;' + '년제'}} - {{ max_experience === null || max_experience === 'null' ?  'N/A' : max_experience + '&nbsp;' + '년제'}}</p>
                        <p v-else-if="career === 'any'">{{ $t('any') }}</p>
                        <!-- <p>{{ career }} / {{ min_experience === 'null' ? 'N/A' : min_experience }} - {{ max_experience === 'null' ? 'N/A' : max_experience }}</p> -->
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="category_name_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.NoticePeriod') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p v-if="notice_posting_period === '' || notice_posting_period === null">N/A</p>
                        <p v-else-if="notice_posting_period == '1_days'">{{ $t('1_days') }}</p>
                        <p v-else-if="notice_posting_period == '2_days'">{{ $t('2_days') }}</p>
                        <p v-else-if="notice_posting_period == '3_days'">{{ $t('3_days') }}</p>
                        <p v-else-if="notice_posting_period == '4_days'">{{ $t('4_days') }}</p>
                        <p v-else-if="notice_posting_period == '5_days'">{{ $t('5_days') }}</p>
                        <p v-else-if="notice_posting_period == '6_days'">{{ $t('6_days') }}</p>
                        <p v-else-if="notice_posting_period == '7_days'">{{ $t('7_days') }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="title_en" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.WorkingRegion') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ region_1st }} - {{ region_2nd }} - {{ region_3rd }}</p>
                    </div>
                </div>

                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.CompanyAddress') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ company_address }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.DetailAddress') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ job_detail_address == 'null' ? 'N/A' : job_detail_address }}</p>
                    </div>
                </div>
                <div class="p-field p-grid">
                    <label for="title_en" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.NoofEmployees') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ num_of_recruitment }} {{ $t('Peoples') }}</p>
                    </div>
                </div>

                <div class="p-field p-grid">
                    <label for="description_ko" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Free1.view.Sectors') }}:</label>
                    <div class="p-col-12 p-md-10">
                        <p>{{ industry_name }}</p>
                    </div>
                </div>

                <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                    <Button :label="$t('Free1.view.Approve')" class="p-button-outlined p-button p-mr-2 p-mb-2" @click="Approved" id="Approve" icon="pi pi-check" iconPos="left" :disabled="status == 1 || status == 2 ? true : false"> </Button>
                    <Button :label="$t('Free1.view.Rejected')" class="p-button-outlined p-button p-mr-2 p-mb-2" @click="openResponsive" id="Reject" icon="pi pi-times" iconPos="left" :disabled="status == 1 || status == 2 ? true : false"> </Button>
                </div>
                <br /><br />
                <!-- <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                    <Button @click="del($route.params.id)" :label="$t('notice1.view.Delete')" class="p-button-outlined p-button-danger p-mr-2 p-mb-2"> </Button>
                </div> -->
                <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                    <Button :label="$t('Free1.view.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="$router.go(-1)" style="margin-top: -20px"></Button>
                </div>
            </div>
        </div>
    </div>
    <Dialog :header="$t('Free1.view.Alert')" v-model:visible="displayResponsive" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '34vw' }">
        <p class="text-choose">
            <b>{{ $t('Free1.view.ReasonSelect') }}</b>
        </p>
        <div class="p-col-12 p-md-10" id="reason">
            <Dropdown v-model="reason" :options="ReasonDropDowns" optionLabel="name" optionValue="name" :placeholder="$t('Free1.view.Select')" name="name" id="first_category" :class="`${error.reason ? 'p-invalid' : ''}`" />
            <div class="p-col-12 p-md-12" id="error-text">
                <small class="text-red" id="red">{{ error.reason }}</small>
            </div>
        </div>
        <template #footer>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: right">
                <Button :label="$t('Free1.view.Confirm')" icon="pi pi-check" @click="RejectUpdate" id="reject" />
            </div>
            <div class="p-d-flex p-jc-end p-ai-center dual-btn" style="float: left">
                <Button :label="$t('Free1.view.Cancel')" icon="pi pi-replay" @click="closeResponsive" class="p-button p-button p-button-outlined" style="background: white; color: black" />
            </div>
        </template>
    </Dialog>
</template>
<script>
// import axios from 'axios';
import FreeService from '../../../service/API/FreeService';
// import {useRouter} from 'vue-router'
import moment from 'moment';
import validateReason from '../../../validations/Free/validateReason';

// import Dialog from 'primevue/dialog';
export default {
    data() {
        return {
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            ReasonDropDowns: [
                { name: '유흥, 불건전, 불법, 음란, 도박, 신고중복, 임금체불 업체 공고' },
                { name: '점포개설, 프랜차이즈 모집, 선거관련, 다단계, 카드, 가입자 유치, 홍보, 모금, 선입금 등 채용이 아닌 공고' },
                { name: '선원법에 저촉된 선원 모집, 학원 수강생(배우면서 일하기) 모집 공고' },
                { name: '실제와 다르거나 중요 정보미기입, 미등록 기업, 불법 허위 공고' },
            ],
            ReasonDropDown: null,
            // mydata: {
            company_name: '',
            manager_name: '',
            job_posting_title: '',
            salary: '',
            pay_type: '',
            working_mode: '',
            probation: '',
            working_hour_from: '',
            working_hour_end: '',
            career: '',
            min_experience: '',
            max_experience: '',
            notice_posting_period: '',
            company_address: '',
            num_of_recruitment: '',
            industry: '',
            status: '',
            industry_name: '',
            region_1st: '',
            region_2nd: '',
            region_3rd: '',
            job_selection: '',
            job_positions: '',
            job_detail_address:'',

            // },
            id: '',
            job_id: '',
            reason: '',

            displayResponsive: false,
            error: {},
            WeekendDays: ['월', '화', '수', '목', '금', '토', '일'],
            job_working_days: [],
        };
    },
    created() {
        this.freeService = new FreeService();
    },
    methods: {
        formatSalary(value) {
            // Convert the value to a string and add comma separators
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY/MM/DD');
            }
        },
        editnotice(id) {
            this.noticeService.viewNotice(id).then((result) => {
                localStorage.setItem('desc', JSON.stringify(result[0]));
                // alert(res.result)
                // console.log(result[0].description)
            });
        },
        openResponsive() {
            this.displayResponsive = true;
        },
        closeResponsive() {
            this.displayResponsive = false;
        },
        Approved() {
            this.freeService.ApproveFree({ job_id: this.$route.params.id, status: '1', reason: '' }).then((res) => {
                console.warn(res);
                this.$router.push({ name: 'Free' });
                setTimeout(() => {
                    this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '공고를 승인했습니다.', life: 3000 });
                }, 500);
            });
        },
        RejectUpdate() {
            let vcheckData = {
                reason: this.reason,
            };
            const { isInvalid, error } = validateReason(vcheckData);
            if (isInvalid) {
                this.error = error;
                console.log(error);
            } else {
                this.error = '';
                this.freeService.Rejected({ job_id: this.$route.params.id, status: '2', reason: this.reason }).then((res) => {
                    console.warn(res);
                    this.$router.push({ name: 'Free' });
                    setTimeout(() => {
                        this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '공고를 반려했습니다.', life: 3000 });
                    }, 500);
                });
            }
        },
    },
    computed: {
        weekdays() {
            // Map selected working days to their corresponding weekdays
            return this.job_working_days.map((day) => this.WeekendDays[day - 1]);
        },
    },
    mounted() {
        this.freeService.FreeView(this.$route.params.id).then((result) => {
            // console.log(result);
            this.company_address = result.company_address;
            this.company_name = result.company_name;
            this.industry = result.industry;
            this.manager_name = result.manager_name;
            this.job_posting_title = result.job_posting_title;
            this.salary = result.salary;
            this.career = result.career;
            this.notice_posting_period = result.notice_posting_period;
            this.probation = result.probation;
            this.pay_type = result.pay_type;
            this.working_mode = result.working_mode;
            this.num_of_recruitment = result.num_of_recruitment;
            this.working_hour_end = result.working_hour_end;
            this.working_hour_from = result.working_hour_from;
            this.min_experience = result.min_experience;
            this.max_experience = result.max_experience;
            this.industry_name = result.industry_name;
            this.region_1st = result.region_1st;
            this.region_2nd = result.region_2nd;
            this.region_3rd = result.region_3rd;
            this.job_positions = result.job_positions;
            this.job_selection = result.job_selection;
            this.status = result.status;
            this.job_working_days = result?.job_working_days;
            this.job_detail_address = result.job_detail_address;

            // localStorage.setItem('desc', result[0].description);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}

.renderHtml {
    background-color: #fcfcfc;
    padding: 25px;
    border: 1px solid rgba(70, 77, 242, 0.2);
    border-radius: 5px;
    margin-top: 15px;
}

/* .card.p-fluid {
    height: 100vh;
} */
.p-d-flex.p-jc-end.p-ai-center.dual-btn {
    margin-top: 13px;
}

div#first_category {
    width: 81%;
    align-items: center;
}

p.text-choose {
    text-align: center;
    font-size: 20px;
}

div#reason {
    float: right;
}

#reject {
    background: black;
    color: white;
}

button#Reject {
    background: red;
    color: white;
}

button#Approve {
    background: green;
    color: white;
}
small#red {
    float: left;
    margin-top: -10px;
    margin-left: -11px;
}
</style>
